import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "2500",
  height: "2500",
  fill: "none",
  viewBox: "0 0 154 154"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "77",
      cy: "77",
      r: "77",
      fill: "#05998b"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m81.375 18.667-38.75 70H77.5l-3.875 46.666 38.75-70H77.5z"
    }, null, -1)
  ])))
}
export default { render: render }